import { styled } from '@mui/system';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, List, ListItem, ListItemText } from '@mui/material';
import { Typography, } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import { MenuItem } from "@mui/material";

export const Wrapper = styled("div")({
    // border: "2px solid red",
    width: "100%",
    height: "100%"
});

export const StyledTable = styled(Table)({
    borderCollapse: 'collapse',
    width: '100%',
    '& th, & td': {
        border: '1px solid #dddddd',
        textAlign: 'left',
        padding: '8px',
    },
    '& th': {
        backgroundColor: '#f2f2f2',
    },
    '& td': {
        backgroundColor: '#ffffff',
    },
});

export const DropZone = styled('div')({
    border: '2px dashed #cccccc',
    borderRadius: '4px',
    color: "black",
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    marginBottom: '20px',
    '&.dragover': {
        backgroundColor: '#e0e0e0',
    },
});

// Styled List to handle wrapping
export const StyledList = styled(List)({
    color: 'black',
    display: 'flex',
    flexWrap: 'wrap',
    gap: "5px",
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    width: '100%', // Ensure it fills the container width
});



export const AttachementWrapper = styled("div")({
    border: "2px solid #cccccc",
    width: "35%",
    height: "50%",
    padding: "20px",
    marginLeft: "30%",
    marginTop: "5%",
});


export const TableWrapper = styled("div")({
});

export const FileDetailWrapper = styled("div")({
    border: "2px solid #1976d2",
    // width: "170px",
    width: "40%",
    padding: "3px",
    borderRadius: "25px"
});

export const FileNameTypography = styled(Typography)(({ }) => ({
    fontSize: "12px",
}));

export const RefreshWrapper = styled(RefreshIcon)(({ }) => ({
    height: "30px",
    width: "30px",
    border: "2px solid #1976d2",
    backgroundColor: "#1976d2",
    color: "white",
    borderRadius: "50%",
}));

export const StyleMenu = styled(MenuItem)(({ theme }) => ({
    border: "2px solid #1976d2",
    fontWeight: 600,
    "& svg": {
        height: "auto",
        marginLeft: "-10px",
        marginRight: "10px",
    },
}));

export const RadioButtonWrapper = styled("div")({
    marginLeft: "20px",
    marginTop: "40px",
});

export const LabelWrapper = styled("label")({
    display: "flex",
    gap: "15px",
});

